<template>
	<tr class="tableTr" @dblclick="onEdit">
		<td class="dense" :class="{'tdGreen': checkClasses['filter_id']}">{{ item.id }}</td>
        <td :class="{'tdGreen': checkClasses['filter_create_at']}">{{ item['create_at'] }}</td>
		<td class="dense" :class="{'tdGreen': checkClasses['filter_wo_type']}">{{ item['wo_type'] }}</td>
<!--		<td :class="{'tdGreen': checkClasses['filter_unit_type']}">{{ item['unit_type'] }}</td>
		<td :class="{'tdGreen': checkClasses['filter_unit']}">{{ item.unit }}</td>-->
		<td class="center dense" :class="{'tdGreen': checkClasses['filter_arrived']}">
			<svg-sprite v-if="item.arrived" height="16" width="17" icon-id="done"></svg-sprite>
		</td>
        <td :class="{'tdGreen': checkClasses['filter_arrival_date']}">{{ item['arrival_date'] }}</td>
		<td class="dense" width="120">
			<div class="icons">
          <svg-sprite
              :style="getIconColor(item['option_inspection'])"
              width="25"
              height="24"
              icon-id="inspection"
          ></svg-sprite>
				<svg-sprite
						:style="getIconColor(item['option_alignment'])"
						width="25"
						height="24"
						icon-id="alignment"
				></svg-sprite>
				<svg-sprite :style="getIconColor(item['option_pm'])" width="25" height="24" icon-id="pm"></svg-sprite>
				<svg-sprite :style="getIconColor(item['option_towing'])" width="25" height="24" icon-id="towing"></svg-sprite>
			</div>
		</td>
    <td :class="{'tdGreen': checkClasses['filter_dispatch_request']}" align="center">
        <span @click="onCommentsPopup" class="descN">{{ item.dispatch_request }}</span>
    </td>
		<td :class="{'tdGreen': checkClasses['filter_status']}">
			<div class="status">
				<span class="status_color" :style="`background: ${item.color}`"></span>
				<span>{{ item.status }}</span>
			</div>
		</td>
		<td :class="{'tdGreen': checkClasses['filter_check_in'] || filterClassesActive('filter_check_in')}">{{ item['check_in'] }}</td>
		<td :class="{'tdGreen': checkClasses['filter_check_out'] || filterClassesActive('filter_check_out')}">{{ item['check_out'] }}</td>
		<td :class="{'tdGreen': checkClasses['filter_technician']}">{{ item['technician'] }}</td>
		<td class="dense" :class="{'tdGreen': checkClasses['filter_total']}">
			<span v-if="item.total !== null">$</span>
			{{ getTotal(item.total) }}
		</td>
	</tr>
</template>

<script>
import { formatCurrency } from "@/helper";

export default {
	name: "TableTr",
	props: {
		item: Object,
		permissions: Object,
		checkClasses: Object,
		filterClassesActive: Function,
		idx: Number
	},
	methods: {
		getIconColor(value) {
			const color = value ? '#19BC38' : '#8F90A6';
			return `color: ${ color }`;
		},
		onEdit() {
			this.$emit('updateEdit', this.item.id);
		},
		getTotal(total) {
			return formatCurrency(total);
		},
		onCommentsPopup() {
			const { id, unit, unit_type } = this.item;
			this.$emit('updateCommentsPopup', { id, unit, unit_type });
		}
	}
};
</script>
